export const seoMetadata = {
  appName: 'KawaTenda',
  seoName: 'KawaTenda',
  shareName: 'kawatenda',
  canonicalUrl: 'https://tenda.kawatech.com.br/',
  title: 'KawaTenda | Gestao operacional e financeira',
  description:
    'KawaTenda centraliza vendas, estoque, faturamento, despesas, visitas e clientes em um WebApp multi-tenant para equipes operacionais.',
  shortDescription:
    'Gestao operacional e financeira multi-tenant para vendas, estoque, faturamento, despesas e clientes.',
  keywords: [
    'KawaTenda',
    'gestao operacional',
    'gestao financeira',
    'controle de estoque',
    'faturamento',
    'PDV',
    'multi-tenant',
    'KawaTech',
  ],
  locale: 'pt_BR',
  themeColor: '#282b5f',
};

const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const brandingAssetUrl = (asset) => `${backendUrl}/api/branding/kawatech/${asset}`;

export const kawatechOfficialLogos = {
  positive: brandingAssetUrl('logo-positive'),
  negative: brandingAssetUrl('logo-negative'),
  iconPositive: brandingAssetUrl('icon-positive'),
  iconNegative: brandingAssetUrl('icon-negative'),
};

export const brandPalette = {
  primary: '#282b5f',
  secondary: '#d2314b',
  tertiary: '#f6f7fb',
  background: '#ffffff',
  text: '#202338',
};
